export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'Un niveau d\'intervention du même nom existe déjà dans cet établissement'
    }
  }
}
